export default {
  placeholder: 'Select a loading scheme',
};
